import Modal, { ModalProps } from '@anm/components/modals/Modal';
import { CloseButton } from '@anm/styles/helpers';
import { FC } from 'react';

import Wrapper, { Content, Title } from './Wrapper';

export type TeamModalProps = Pick<ModalProps, 'onModalClose'> & { className?: string; title: string };

const TeamModal: FC<TeamModalProps> = ({ title, className, children, onModalClose }) => (
  <Modal onModalClose={onModalClose}>
    <Wrapper className={className}>
      <Title>{title}</Title>
      <CloseButton onClick={onModalClose} />
      <Content>{children}</Content>
    </Wrapper>
  </Modal>
);

export default TeamModal;
